import { InputMask } from "@react-input/mask";
import { formatPhonePt } from '../../utils/functions';

function PhoneInput({ 
    className,
    placeholder,
    value,
    onChange }) {
  return (
    <InputMask
        className={className}
        placeholder={placeholder}
        mask="+351 ___ ___ ___"
        replacement={{ _: /\d/ }}
        value={formatPhonePt(value)}
        onChange={onChange}
    />
  );
}

export default PhoneInput;
